import { render, staticRenderFns } from "./diff_content.vue?vue&type=template&id=e49698bc&"
import script from "./diff_content.vue?vue&type=script&lang=js&"
export * from "./diff_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diff_content.vue"
export default component.exports